define(["exports", "./pubsubhub"], function (_exports, _pubsubhub) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.name = void 0;
  // @ts-check
  // Module core/include-config
  // Inject's the document's configuration into the head as JSON.
  const name = "core/include-config";
  _exports.name = name;
  const userConfig = {};

  const amendConfig = newValues => Object.assign(userConfig, newValues);

  const removeList = ["githubToken", "githubUser"];
  (0, _pubsubhub.sub)("start-all", amendConfig);
  (0, _pubsubhub.sub)("amend-user-config", amendConfig);
  (0, _pubsubhub.sub)("end-all", () => {
    const script = document.createElement("script");
    script.id = "initialUserConfig";
    script.type = "application/json";

    for (const prop of removeList) {
      if (prop in userConfig) delete userConfig[prop];
    }

    script.innerHTML = JSON.stringify(userConfig, null, 2);
    document.head.appendChild(script);
  });
});
//# sourceMappingURL=include-config.js.map